<template>
	<v-btn text class="mt-2 error--text" @click="unlink(placeId)">Desvicunlar </v-btn>
</template>

<script>
import { mapActions } from 'vuex';
export default {
	name: 'UnlinkButton',
	props: {
		placeId: {
			type: String,
			required: true,
		},
	},
	methods: {
		async unlink(placeId) {
			await this.unlinkSharedPlace(placeId);
			await this.fetchPlace();
		},
		...mapActions({
			unlinkSharedPlace: 'Place/unlinkSharedPlace',
			fetchPlace: 'Place/fetchPlace',
		}),
	},
};
</script>

<style scoped></style>
